module.exports = __webpack_public_path__ + "img/Home1.b8167b05.png";